import { PageComponent, PageState, PageSubset } from "barba"
import TinySlider from "utils/tiny-slider"

const pageStateStartIndex = 'bike-heading-startIndex'

class BikeHeadingClass {

    constructor({ node }) {
        this.heading = node
        this.filter = this.heading.querySelector('.bike-heading-head__filter')
        this.specs = this.heading.querySelector('.bike-heading-specs')
        this.slider = null
        
        this.openSpecsHandler = this.openSpecs.bind(this)
        this.focusinSpecsHandler = e => {
            // Conflict with "is-within", for this reason stopPropagation().
            e.stopPropagation()
        }
        this.openMediaViewerHandler = this.openMediaViewer.bind(this)

        this.filter.addEventListener('click', this.openSpecsHandler)
        this.filter.addEventListener('focusin', this.focusinSpecsHandler)
        this.heading.addEventListener("click", this.openMediaViewerHandler)

        this.sliderOpts = () => ({
            mode: this.isGallery() ? 'gallery' : 'carousel',
            container: this.heading.querySelector('.bike-heading-slider__tns'),
            prevButton: this.heading.querySelector('.bike-heading-ctrl-prev'),
            nextButton: this.heading.querySelector('.bike-heading-ctrl-next'),
            navPosition: 'bottom',
            speed: 500,
            startIndex: PageState.get(pageStateStartIndex) || 0
        })
        
        if (this.heading.querySelectorAll('.bike-heading-slider__pic').length > 1) {
            this.slider = new TinySlider(this.sliderOpts)
            this.slider.events.on('indexChanged', i => {
                PageState.set(pageStateStartIndex, Math.max(0, i.displayIndex - 1))
            })
        }
    }

    openSpecs(e) {
        // The class is also driven with "is-within", 
        // for this reason we use stopPropagation().
        const clas = 'bike-heading-specs--open'
        if (!this.specs.classList.contains(clas)) {
            this.specs.classList.add(clas)
            e.stopPropagation()
        }
    }

    isGallery() {
        return window.matchMedia("(min-width: 992px)").matches
    }

    openMediaViewer(e) {
        const item = e.target.closest('[data-slide-index]')
        if (!item) return
        const index = item.dataset.slideIndex
        PageSubset.open('mv-bike-heading', { 'startIndex': Math.max(0, index) })
    }

    destroy() {
        if (this.slider && this.slider.destroy) {
            this.slider.destroy()
        }
        
        this.filter.removeEventListener('click', this.openSpecsHandler)
        this.filter.removeEventListener('focusin', this.focusinSpecsHandler)
        this.heading.removeEventListener('click', this.openMediaViewerHandler)

        delete this.heading
        delete this.filter
        delete this.specs
        delete this.sliderOpts
        delete this.slider

        delete this.openSpecsHandler
        delete this.focusinSpecsHandler
        delete this.openMediaViewerHandler
    }

}

new PageComponent(".bike-heading", BikeHeadingClass)